<template>
  <div id="GoTop">
    <!--右侧悬浮-->
    <div class="rightNav">
      <div class="weixin-wrapper">
        <div
          class="rightNav-in weixin weixin-trigger"
          @mouseover="showOverlay = true"
          @mouseout="showOverlay = false"
        >
          <span><img alt="" src="../assets/img/weixinleft.png" /></span>
          <p data-i18n="wechat">微信</p>
        </div>
        <transition name="slide-fade-left">
          <div
            class="weixin-overlay"
            style="float: left; position: absolute"
            v-show="showOverlay"
            @mouseenter="showOverlay = true"
            @mouseleave="showOverlay = false"
          >
            <div class="overlay-content">
              <img src="../assets/img/wx.jpg" alt="微信二维码" />
              <p>扫描二维码联系我们</p>
              <!-- <button @click="showOverlay = false" class="close-btn">×</button> -->
            </div>
          </div>
        </transition>
      </div>
      <div>
        <div
          class="rightNav-in weixin weixin-trigger"
          @mouseover="showGzh = true"
          @mouseout="showGzh = false"
        >
          <span><img alt="" src="../assets/img/erweima.png" /></span>
          <p data-i18n="gongzh">公众号</p>
        </div>
        <div class="rightNav-ewm maximg">
          <img alt="" src="../assets/img/weixinleft.png" />
        </div>
      </div>
      <transition name="slide-fade-left">
        <div
          class="gzh-overlay"
          style="float: left; position: absolute"
          v-show="showGzh"
          @mouseenter="showGzh = true"
          @mouseleave="showGzh = false"
        >
          <div class="overlay-content">
            <img src="../assets/img/wx.jpg" alt="微信二维码" />
            <p>扫描二维码联系我们</p>
            <!-- <button @click="showOverlay = false" class="close-btn">×</button> -->
          </div>
        </div>
      </transition>
      <div>
        <div
          class="rightNav-in weixin weixin-trigger"
          @mouseover="showDh = true"
          @mouseout="showDh = false"
        >
          <span><img alt="" src="../assets/img/phone.png" /></span>
          <p data-i18n="contact">联系电话</p>
        </div>
        <transition name="slide-fade-left">
          <div
            class="gzh-overlay"
            style="float: left; position: absolute"
            v-show="showDh"
            @mouseenter="showDh = true"
            @mouseleave="showDh = false"
          >
            <div class="overlay-content">
              <!-- <img src="../assets/img/wx.jpg" alt="微信二维码" /> -->
              <p>13679955823</p>
              <!-- <button @click="showOverlay = false" class="close-btn">×</button> -->
            </div>
          </div>
        </transition>
      </div>

      <div
        v-show="!isAtTop"
        class="zhiding scrollable"
        id="zhiding"
        @click="GoTop()"
      >
        <div class="rightNav-in" title="">TOP</div>
      </div>
    </div>
  </div>
</template>
<script>
import { translatePage } from "../assets/js/languages/change_language";
export default {
  name: "GoTop",
  data() {
    return {
      // lang: "zh", // 默认中文，可切换 'en'
      flag: false,
      isAtTop: true,
      showOverlay: false,
      showGzh: false,
      showDh: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    translatePage();
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    GoTop() {
      (function smoothscroll() {
        var currentScroll =
          document.documentElement.scrollTop || document.body.scrollTop;
        console.log(currentScroll);
        if (currentScroll > 0) {
          window.requestAnimationFrame(smoothscroll);
          window.scrollTo(0, currentScroll - Math.ceil(currentScroll / 10));
        }
      })();
    },
    handleScroll() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0;
      this.isAtTop = scrollTop < 100; // 当滚动到顶部100px以内时隐藏元素
    },
  },
};
</script>
<!-- <script src="../assets/js/languages/change_language.js"></script> -->
<style>
/*右侧导航*/
.weixin-wrapper {
  position: absolute;
  display: inline-block;
}

.weixin-trigger {
  cursor: pointer;
  transition: all 0.3s;
  position: absolute;
  z-index: 1;
  display: flex;
  align-items: center;
  padding: 8px 12px;
}

.weixin-trigger:hover {
  color: #1890ff;
  background-color: rgba(24, 144, 255, 0.1);
  border-radius: 4px;
}

.weixin-overlay {
  position: absolute;
  top: -1px;
  right: 100%; /* 从左侧弹出 */
  margin-right: 10px; /* 与触发元素的间距 */
  background-color: white;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  z-index: 10;
  min-width: 200px;
}
.gzh-overlay {
  position: absolute;
  top: -1px;
  right: 100%; /* 从左侧弹出 */
  margin-right: 10px; /* 与触发元素的间距 */
  background-color: white;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  z-index: 10;
  min-width: 200px;
}
.dianhua-overlay {
  position: absolute;
  top: -1px;
  right: 100%; /* 从左侧弹出 */
  margin-right: 10px; /* 与触发元素的间距 */
  background-color: white;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  z-index: 10;
  min-width: 200px;
}
.overlay-content {
  padding: 15px;
  text-align: center;
}

.overlay-content img {
  width: 160px;
  height: 160px;
  display: block;
  margin: 0 auto 10px;
}

.overlay-content p {
  margin: 0;
  font-size: 14px;
  color: #666;
}

/* 左侧弹出动画 */
.slide-fade-left-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-left-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-left-enter,
.slide-fade-left-leave-to {
  transform: translateX(-10px);
  opacity: 0;
}

/* 添加小三角箭头（右侧） */
.weixin-overlay::after {
  content: "";
  position: absolute;
  top: 15px;
  right: -6px;
  width: 0;
  height: 0;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-left: 6px solid white;
  filter: drop-shadow(2px 0 1px rgba(0, 0, 0, 0.1));
}
.gzh-overlay::after {
  content: "";
  position: absolute;
  top: 155px;
  right: -6px;
  width: 0;
  height: 0;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-left: 6px solid white;
  filter: drop-shadow(2px 0 1px rgba(0, 0, 0, 0.1));
}
.dianhua-overlay::after {
  content: "";
  position: absolute;
  top: 15px;
  right: -6px;
  width: 0;
  height: 0;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-left: 6px solid white;
  filter: drop-shadow(2px 0 1px rgba(0, 0, 0, 0.1));
}
/* 过渡动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.rightNav {
  display: block;
  width: 70px;
  position: fixed;
  right: 0;
  top: 50%;
  z-index: 90;
}
.rightNav div {
  position: relative;
  margin-bottom: 1px;
}
.rightNav-in {
  text-decoration: none;
  display: block;
  width: 80px;
  height: 70px;
  /*background-color: #2b5fbc;*/
  background: rgba(0, 57, 135, 0.5);
  text-align: center;
  font-size: 13px;
  color: #fff;
  line-height: 24px;
  padding-top: 8px;
}
.rightNav-in span {
  text-decoration: none;
  display: block;
  width: 35px;
  height: 35px;
  margin: 0 auto;
}
.rightNav .zhiding .rightNav-in {
  text-decoration: none;
  background-color: #dcdcdc;
  margin-top: 6px;
  background-image: url(../assets/img/sanjiao-01.png);
  background-repeat: no-repeat;
  background-position: center 20px;
  background-size: 6px 5px;
  font-size: 14px;
  color: #484747;
  text-transform: uppercase;
  line-height: 24px;
  padding-top: 32px;
}
.rightNav .zhiding .rightNav-in:hover {
  text-decoration: none;
  text-decoration: none;
  background-color: #2b5fbc;
  background-image: url(../assets/img/sanjiao-02.png);
  color: #fff;
}
.rightNav-ewm {
  display: none;
  width: 120px;
  height: 120px;
  border-radius: 6px;
  background: rgba(0, 57, 135, 0.6);
  padding: 10px;
  position: absolute;
  right: 90px;
  top: 50%;
  margin-top: -60px;
  box-shadow: 0 0 26px 0 rgba(0, 0, 0, 0.3);
  text-align: center;
  line-height: 100px;
  opacity: 0;
  transition: opacity 0.4s;
}
.rightNav-ewm::after {
  display: block;
  content: "";
  width: 0;
  height: 0;
  border-top: 8px solid transparent;
  border-left: 8px solid rgba(0, 57, 135, 0.6);
  border-bottom: 8px solid transparent;
  position: absolute;
  left: 100%;
  top: 50%;
  transform: translateY(-50%);
  z-index: 9;
}
.rightNav-phone {
  display: none;
  width: auto;
  padding: 0 20px;
  border-radius: 6px;
  background: rgba(0, 57, 135, 0.6);
  font-size: 20px;
  color: #fff;
  line-height: 48px;
  position: absolute;
  right: 90px;
  top: 50%;
  margin-top: -24px;
  white-space: nowrap;
  box-shadow: 0 0 26px 0 rgba(0, 0, 0, 0.3);
  opacity: 0;
  transition: opacity 0.4s;
}
.rightNav-phone::after {
  display: block;
  content: "";
  width: 0;
  height: 0;
  border-top: 8px solid transparent;
  border-left: 8px solid rgba(0, 57, 135, 0.6);
  border-bottom: 8px solid transparent;
  position: absolute;
  left: 100%;
  top: 50%;
  transform: translateY(-50%);
  z-index: 9;
}
.rightNav li:hover > div {
  text-decoration: none;
  display: block;
}
#GoTop {
  width: 50px;
  height: 50px;
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 99999999;
  cursor: pointer;
}
#GoTop > span {
  display: block;
  width: 100%;
  height: 100%;
  color: rgb(8, 162, 233);
  font-size: 30px;
}
.imgsty {
  text-align: center;
  width: 80px;
  color: #fff;
  /* height: 50px; */
  position: fixed;
  right: 1px;
  /* bottom: 150px; */
  z-index: 99999999;
  cursor: pointer;
  background-color: #93addb;
  border: #fff 1px solid;
}
/* img{
  width: 40px;
  height: 40px;
  margin: 0 20px 0 20px;
} */
</style>



// WEBPACK FOOTER //
// src/components/GoTop.vue